import { createFilterStore } from './createFilterStore';

export const usePaymentFilterStore = createFilterStore({
  page: 1,
  limit: 20,
  search: '',
  accountId: '',
  sortBy: 'paymentDate',
  sortOrder: 'desc' as const,
});
